import styled from "styled-components";
import { FlexContainer,SecondaryButton,PrimaryButton,GradientText } from "./styled";
import EnergFleskImage from "../assets/images/energyFlesk.png";

const JoinPvpModalContent = ({price,onClose,onDone ,aditionalItem}) => {
    return (
        <ContentContainer>
            <Title>
            <GradientText>
            Join fee {price} Energy Flesk
            Are you sure?
                </GradientText>    
            </Title>
            <PriceContainer>
                <img src={EnergFleskImage} style={{position:"absolute",left:"4px",width:"64px"}}/>
                <GradientText style={{fontSize:"20px",fontWeight:"700",textAlign:"center",paddingLeft:"70px"}}>{price} Energy Flesk</GradientText>
            </PriceContainer>
            {aditionalItem && 
             <PriceContainer>
                <img src="https://cryptid-hunter-mini.s3.eu-central-1.amazonaws.com/market/tickets/lotteryTicket.png" style={{position:"absolute",left:"4px",width:"64px"}}/>
                <GradientText style={{fontSize:"20px",fontWeight:"700",textAlign:"center",paddingLeft:"70px"}}>{aditionalItem.count} Lucky Pass</GradientText>
            </PriceContainer>
            }
            <FlexContainer>
                <PrimaryButton onClick={()=>onClose()} style={{height:"43px"}}>No</PrimaryButton>
                <SecondaryButton onClick={()=>onDone()} style={{width:"100%",background:"linear-gradient(180deg, #9939AD 12.44%, #40297C 45.28%, #250964 50.97%, #582063 100%)",cursor:"pointer"}}>Yes</SecondaryButton>
            </FlexContainer>
        </ContentContainer>
    );
}





const ContentContainer = styled(FlexContainer)`
    flex-direction: column;
    gap: 0;
    padding: 16px 22px;
    align-items: center;
    overflow-y: auto;
    padding-bottom: 24px;
`;

const Title = styled.div`
    font-size: 18px;
    font-weight: 700;
    color: #fff;
    margin-bottom: 16px;
   width: 242px;
    padding: 16px 24px;
    text-align: center;
    position: absolute;
    top: -50px;
    `
const PriceContainer = styled.div`
background: #6943B994;
backdrop-filter: blur(16px);
border-radius: 10px;
height: 43px;
width: 80%;
margin-bottom: 24px;
border: 1px solid #CE9DE4;
/* max-width: 162px; */
display: flex;
align-items: center;
position: relative;


`
export default JoinPvpModalContent;